export const TANK_SENSOR_TYPES = {
  HYDROSTATIC_BS8PT_KPA: "hydrostatic_bs8pt_kpa",
  HYDROSTATIC_BS8PT_BAR: "hydrostatic_bs8pt_bar",
  HYDROSTATIC_BS8L1_BAR: "hydrostatic_bs8l1_bar",
  FLOAT: "float",
};

export const DEFAULT_TANK_SENSOR_TYPE = TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_KPA;

export const TANK_SENSOR_TYPE_OPTIONS = [
  {
    value: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_KPA,
    label: "Hydrostatic (BS8PT kpa)",
  },
  {
    value: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_BAR,
    label: "Hydrostatic (BS8PT bar)",
  },
  {
    value: TANK_SENSOR_TYPES.HYDROSTATIC_BS8L1_BAR,
    label: "Hydrostatic (BS8L1 bar)",
  },
  { value: TANK_SENSOR_TYPES.FLOAT, label: "Float" },
];

const SENSOR_TYPE_CODE_BY_VALUE = {
  [TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_KPA]: 1,
  [TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_BAR]: 3,
  [TANK_SENSOR_TYPES.FLOAT]: 2,
  [TANK_SENSOR_TYPES.HYDROSTATIC_BS8L1_BAR]: 4,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  hydrostatic: 1,
  "hydrostatic (bs8pt kpa)": 1,
  "bs8pt kpa": 1,
  bs8pt_kpa: 1,
  "hydrostatic (bs8pt bar)": 3,
  "bs8pt bar": 3,
  bs8pt_bar: 3,
  "hydrostatic (bs8l1 bar)": 4,
  "bs8l1 bar": 4,
  bs8l1_bar: 4,
};

const SENSOR_TYPE_VALUE_BY_ALIAS = {
  1: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_KPA,
  2: TANK_SENSOR_TYPES.FLOAT,
  3: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_BAR,
  4: TANK_SENSOR_TYPES.HYDROSTATIC_BS8L1_BAR,
  hydrostatic: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT_KPA,
};

const SENSOR_TYPE_LABEL_BY_VALUE = TANK_SENSOR_TYPE_OPTIONS.reduce(
  (labels, option) => ({
    ...labels,
    [option.value]: option.label,
  }),
  {
    1: "Hydrostatic (BS8PT kpa)",
    2: "Float",
    3: "Hydrostatic (BS8PT bar)",
    4: "Hydrostatic (BS8L1 bar)",
    hydrostatic: "Hydrostatic (BS8PT kpa)",
  },
);

export const normalizeTankSensorType = (sensorType) => {
  const normalizedType = String(sensorType || "").trim().toLowerCase();
  const option = TANK_SENSOR_TYPE_OPTIONS.find(
    (item) => item.value === normalizedType,
  );

  return (
    option?.value ||
    SENSOR_TYPE_VALUE_BY_ALIAS[normalizedType] ||
    DEFAULT_TANK_SENSOR_TYPE
  );
};

export const getTankSensorTypeCode = (sensorType) => {
  const normalizedType = String(sensorType || "").trim().toLowerCase();
  return SENSOR_TYPE_CODE_BY_VALUE[normalizedType] || 1;
};

export const getTankSensorTypeLabel = (sensorType) => {
  const normalizedType = String(sensorType || "").trim().toLowerCase();

  if (SENSOR_TYPE_LABEL_BY_VALUE[normalizedType]) {
    return SENSOR_TYPE_LABEL_BY_VALUE[normalizedType];
  }

  return sensorType ? String(sensorType).replaceAll("_", " ") : "-";
};
